import { useQuery } from '@tanstack/react-query';
import { getAssetsExchangeRates } from '../requests';

const useAssetsExchangeRates = (
  assetCodeToPay: string,
  assetCodeToReceive: string,
  enabled = true
) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['assets-exchange-rates', assetCodeToPay, assetCodeToReceive],
    queryFn: () =>
      getAssetsExchangeRates({ assetCodeToPay, assetCodeToReceive }),
    enabled: enabled && !!assetCodeToPay && !!assetCodeToReceive,
  });

  return {
    data,
    isLoading,
    isFetching,
  };
};

export { useAssetsExchangeRates };
